import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { lazy, Suspense } from "react";
import "@/App.css";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Analytics from "@/components/Analytics";
import ScrollToTop from "@/components/ScrollToTop";
import HomePage from "@/pages/HomePage";

// Code-split secondary routes — homepage stays eager for best LCP.
const HeritagePage = lazy(() => import("@/pages/HeritagePage"));
const DressesPage = lazy(() => import("@/pages/DressesPage"));
const ArtisansPage = lazy(() => import("@/pages/ArtisansPage"));
const AboutPage = lazy(() => import("@/pages/AboutPage"));
const SupportArtisansPage = lazy(() => import("@/pages/SupportArtisansPage"));
const KcCinem003Page = lazy(() => import("@/pages/KcCinem003Page"));
const BlueprintPage = lazy(() => import("@/pages/BlueprintPage"));

const KC_CINEM_003_PATH = "/collections/kc-cinem/003-1-the-techcare-reaper";

const RouteFallback = () => (
  <div className="min-h-[80vh] flex items-center justify-center bg-[#0B0B0B]">
    <div className="text-[#D4AF37] text-[10px] tracking-[0.42em] uppercase opacity-60">
      Loading…
    </div>
  </div>
);

function App() {
  return (
    <div className="App min-h-screen bg-[#0B0B0B] text-white">
      {/* Global schemas are in index.html for pre-hydration crawlability */}

      <BrowserRouter>
        <Analytics />
        <ScrollToTop />
        <Navbar />
        <main>
          <Suspense fallback={<RouteFallback />}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/heritage" element={<HeritagePage />} />
              <Route path="/artisans" element={<ArtisansPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/support-artisans" element={<SupportArtisansPage />} />
              <Route path="/dresses" element={<DressesPage />} />
              {/* KC-CINEM design archive — index resolves to the latest entry until a series page exists */}
              <Route path="/collections/kc-cinem" element={<Navigate to={KC_CINEM_003_PATH} replace />} />
              <Route path={KC_CINEM_003_PATH} element={<KcCinem003Page />} />
              {/* Individual design blueprints — only slugs defined in data are rendered */}
              <Route path={`${KC_CINEM_003_PATH}/:designSlug`} element={<BlueprintPage />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
